import styles from 'styles/components/common/elements/Spinner.module.scss';

const Spinner = () => {
  return <div className={styles.spinner}></div>;
};

export default Spinner;
